
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { getStatusBadge } from "./ClaimsUtils";

interface ClaimsTableProps {
  claims: any[];
  activeTab: string;
  onViewDetails: (claim: any) => void;
}

/**
 * Table of claims filtered by status.
 */
const ClaimsTable: React.FC<ClaimsTableProps> = ({ claims, activeTab, onViewDetails }) => {
  const filtered = claims.filter(claim => claim.status === activeTab);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nursing Home</TableHead>
          <TableHead>Claimant</TableHead>
          <TableHead>Role</TableHead>
          <TableHead>Date</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Action</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {filtered.map(claim => (
          <TableRow key={claim.id}>
            <TableCell className="font-medium">
              {claim.nursing_home?.center_name || claim.nursing_home_id}
              <div className="text-xs text-muted-foreground">
                {claim.nursing_home?.county}
              </div>
            </TableCell>
            <TableCell>
              {(claim.user?.user_metadata?.first_name || "") + " " + (claim.user?.user_metadata?.last_name || "")}
              <div className="text-xs text-muted-foreground">
                {claim.user?.email}
              </div>
            </TableCell>
            <TableCell>
              {claim.verification_documents?.role || "Not specified"}
            </TableCell>
            <TableCell>
              {claim.created_at ? new Date(claim.created_at).toLocaleDateString() : ""}
            </TableCell>
            <TableCell>
              {getStatusBadge(claim.status)}
            </TableCell>
            <TableCell>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onViewDetails(claim)}
              >
                View Details
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ClaimsTable;
